/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createSendCartShareMessageResponseFromDiscriminatorValue, serializeSendCartShareMessageRequest, serializeSendCartShareMessageResponse, type ErrorResponse, type InternalErrorResponse, type SendCartShareMessageRequest, type SendCartShareMessageResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/messagecenter/carts/send
 */
export interface SendRequestBuilder extends BaseRequestBuilder<SendRequestBuilder> {
    /**
     * Sends the supplied cart snapshot to the recipients with the rep's note and a link to view the cart online without signing in. The snapshot is stored with the message, so the online view shows the cart as shared even after the cart changes or is checked out. The promotions the cart carries (applied promotions, discount code, shipping waiver, and each discount's and free gift's source) are optional and travel with the snapshot. Delivery failures on a channel are reported in the response rather than failing the request.
     * @param body A sales rep shares a shopping cart with the customer by email and/or text. The cart travelsas a snapshot in the request: the recipient sees the cart as it was when shared, and a cartbuilt on the rep's device can be shared before it has synchronized to the server.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<SendCartShareMessageResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 401 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: SendCartShareMessageRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<SendCartShareMessageResponse | undefined>;
    /**
     * Sends the supplied cart snapshot to the recipients with the rep's note and a link to view the cart online without signing in. The snapshot is stored with the message, so the online view shows the cart as shared even after the cart changes or is checked out. The promotions the cart carries (applied promotions, discount code, shipping waiver, and each discount's and free gift's source) are optional and travel with the snapshot. Delivery failures on a channel are reported in the response rather than failing the request.
     * @param body A sales rep shares a shopping cart with the customer by email and/or text. The cart travelsas a snapshot in the request: the recipient sees the cart as it was when shared, and a cartbuilt on the rep's device can be shared before it has synchronized to the server.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: SendCartShareMessageRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const SendRequestBuilderUriTemplate = "{+baseurl}/api/messagecenter/carts/send";
/**
 * Metadata for all the requests in the request builder.
 */
export const SendRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: SendRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createSendCartShareMessageResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeSendCartShareMessageRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
